import get from 'lodash/get';

import { getMenuLength } from 'helpers/getMenuLength';
import LAZY_LOAD_MENU_SIZE from 'constants/menu/lazyLoadMenuSettings';

const _menuLookup = {};

/**
 * determines whether to lazy load menu based on the number of items in the menu
 * can change LAZY_LOAD_MENU_SIZE to configure the size at which menu should lazy load
 * @param {Object} menu
 * @param {number} menu.id
 * @param {Object} state.account
 * @param {boolean} state.account.online_ordering_lazy_loading_disabled
 * @return {boolean}
 */
const shouldLazyLoadMenu = (menu, state) => {
  const isLazyLoadingDisabled = get(
    state.account,
    'online_ordering_lazy_loading_disabled',
    false
  );

  if (isLazyLoadingDisabled) {
    return false;
  }

  const { id } = menu;
  if (!Object.prototype.hasOwnProperty.call(_menuLookup, id)) {
    _menuLookup[id] = getMenuLength(menu) >= LAZY_LOAD_MENU_SIZE;
  }
  return _menuLookup[id];
};

export default shouldLazyLoadMenu;
